import type { FC } from 'react';
import { memo } from 'react';
import SealForm from './form';

import { NodePanelProps } from '../../types';
import type { SealNodeType } from './types';

const Panel: FC<NodePanelProps<SealNodeType>> = ({
  formRef,
  initialValue,
  node_id,
  readonly,
}) => {
  return (
    <SealForm
      node_id={node_id}
      initialValue={initialValue}
      ref={formRef}
      readonly={readonly}
    />
  );
};

export default memo(Panel);
